import { IconProps } from './types';
export const InfoCircleIcon = ({
  size = 24,
  color = 'currentColor',
  bgColor = 'transparent',
  id,
  ...props
}: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    id={id}
    fill={color}
    stroke={bgColor}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.25 10a.75.75 0 0 1 .75-.75h1.75V17a.75.75 0 0 1-1.5 0v-6.25H11a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M9.25 17a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path d="M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
  </svg>
);
